<template>
  <form class="form" method="post">

    <div id="appStatisticsVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appSettings">
        <h2 id="codeMode">-</h2>
        <div class="appStatisticsEntete">
          <div>
            <p>Date de début</p>
            <input type="date" id="date1" class="appInputStyle1">
          </div>
          <div>
            <p>Date de fin</p>
            <input type="date" id="date2" class="appInputStyle1">
          </div>
          <button @click.prevent="listInvoiceAndSpendings()" type="submit" class="appButtonModel2">Actualiser</button>
          <button @click.prevent="routerIncomes()" type="submit" class="appButtonModel2">Exporter PDF Recettes</button>
          <button @click.prevent="routerSpendings()" type="submit" class="appButtonModel2">Exporter PDF Dépenses</button>
        </div>
        <br>
        <div>
          <table class="appStatisticsTable">
            <td class="appStatisticsTable01">
              <tr class="appStatisticsTableStyle1">Quantité</tr>
            </td>
            <td class="appStatisticsTable01">
              <tr>Factures</tr>
            </td>
            <td class="appStatisticsTable01">
              <tr id="tableResultQuantity">-</tr>
            </td>
          </table>

          <table class="appStatisticsTable">
            <td class="appStatisticsTable02">
              <tr class="appStatisticsTableStyle1">Recettes</tr>
            </td>
            <td class="appStatisticsTable02">
              <tr>Prestations</tr>
              <tr>Ventes</tr>
              <tr>Remises</tr>
              <tr>Réductions</tr>
              <tr class="appStatisticsTableStyle1">Total CA</tr>
            </td>
            <td class="appStatisticsTable02">
              <tr id="tableResultPrestations">-</tr>
              <tr id="tableResultVentes">-</tr>
              <tr id="tableResultRemises">-</tr>
              <tr id="tableResultReduction">-</tr>
              <tr class="appStatisticsTableStyle1" id="tableResultTotalRecettes">-</tr>
            </td>
          </table>

          <button @click.prevent="show_Modes()" type="submit" class="appButtonModel3">v</button>
          <div id="modeName">
            <table class="appStatisticsTable">
              <td class="appStatisticsTable02">
                <tr class="appStatisticsTableStyle1">Par mode</tr>
              </td>
              <td class="appStatisticsTable02">
                <tr>Espèces</tr>
                <tr>Chèques</tr>
                <tr>CB</tr>
                <tr>Virement</tr>
                <tr>Paypal</tr>
              </td>
              <td class="appStatisticsTable02">
                <tr id="tableResultEspeces">-</tr>
                <tr id="tableResultCheques">-</tr>
                <tr id="tableResultCB">-</tr>
                <tr id="tableResultPaylib">-</tr>
                <tr id="tableResultPaypal">-</tr>
              </td>
            </table>
            <button @click.prevent="unshow_Modes()" type="submit" class="appButtonModel3">^</button>
          </div>

          <table class="appStatisticsTable">
            <td class="appStatisticsTable03">
              <tr class="appStatisticsTableStyle1">Achats</tr>
            </td>
            <td class="appStatisticsTable03">
              <tr>Consommables</tr>
              <tr>Matériel</tr>
              <tr>Conso+Matériel</tr>
              <tr class="appStatisticsTableStyle1">Total Achats</tr>
            </td>
            <td class="appStatisticsTable03">
              <tr id="tableResultConsommables">-</tr>
              <tr id="tableResultMaterials">-</tr>
              <tr id="tableResultConsommablesAndMaterials">-</tr>
              <tr class="appStatisticsTableStyle1" id="tableResultTotalAchats">-</tr>
            </td>
          </table>

          <table class="appStatisticsTable">
            <td class="appStatisticsTable03">
              <tr class="appStatisticsTableStyle1">Dépenses</tr>
            </td>
            <td class="appStatisticsTable03">
              <tr>Assurance</tr>
              <tr>Essence</tr>
              <tr>Frais bancaires</tr>
              <tr>Salaire</tr>
              <tr>Téléphone</tr>
              <tr>URSSAF</tr>
              <tr>Autres</tr>
              <tr class="appStatisticsTableStyle1">Total Dépenses</tr>
            </td>
            <td class="appStatisticsTable03">
              <tr id="tableResultAssurance">-</tr>
              <tr id="tableResultEssence">-</tr>
              <tr id="tableResultFraisBancaires">-</tr>
              <tr id="tableResultSalaire">-</tr>
              <tr id="tableResultTelephone">-</tr>
              <tr id="tableResultURSSAF">-</tr>
              <tr id="tableResultAutres">-</tr>
              <tr class="appStatisticsTableStyle1" id="tableResultTotalDepenses">-</tr>
            </td>
          </table>

          <table class="appStatisticsTable">
            <td class="appStatisticsTable04">
              <tr class="appStatisticsTableStyle1">Résultat</tr>
            </td>
            <td class="appStatisticsTable04">
              <tr class="appStatisticsTableStyle1" id="tableResultFinal">-</tr>
            </td>
          </table>
          <br>
          <table class="appStatisticsTable">
            <td class="appStatisticsTable04">
              <tr class="appStatisticsTableStyle1">Solde Compte courant</tr>
              <tr class="appStatisticsTableStyle1">Restant à encaisser</tr>
            </td>
            <td class="appStatisticsTable04">
              <tr class="appStatisticsTableStyle1" id="tableResultFinalBankAccount">-</tr>
              <tr class="appStatisticsTableStyle1" id="tableResultRestant">-</tr>
            </td>
          </table>

        </div>
      </div>
    </div>

  </form>
</template>

<script>
import HeaderApp from '../Application/HeaderApp.vue'
import axios from 'axios'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'Settings',
  data () {
    return {
      statistics: ''
    }
  },
  mounted () {
    var date = new Date()
    document.getElementById('date1').valueAsDate = new Date(date.getFullYear(), date.getMonth(), 2)
    document.getElementById('date2').valueAsDate = date
    this.unshow_Modes()
    this.listInvoiceAndSpendings()
    if (JSON.parse(localStorage.getItem('modePrivilegia')) !== 3) {
      document.getElementById('codeMode').innerText = 'Statistiques'
    } else {
      document.getElementById('codeMode').innerText = 'Statistiques.'
    }
  },
  methods: {
    routerIncomes () {
      localStorage.setItem('privilegiaPDFdate1', document.getElementById('date1').value + 'T00:00:00')
      localStorage.setItem('privilegiaPDFdate2', document.getElementById('date2').value + 'T23:59:00')
      this.$router.push('/App/Statistics/Incomes')
    },
    routerSpendings () {
      localStorage.setItem('privilegiaPDFdate1', document.getElementById('date1').value + 'T00:00:00')
      localStorage.setItem('privilegiaPDFdate2', document.getElementById('date2').value + 'T23:59:00')
      this.$router.push('/App/Statistics/Spendings')
    },
    show_Modes () {
      document.getElementById('modeName').style.display = 'inline'
    },
    unshow_Modes () {
      document.getElementById('modeName').style.display = 'none'
    },
    async listInvoiceAndSpendings () {
      document.getElementById('tableResultQuantity').innerText = '-'
      document.getElementById('tableResultPrestations').innerText = '-'
      document.getElementById('tableResultVentes').innerText = '-'
      document.getElementById('tableResultRemises').innerText = '-'
      document.getElementById('tableResultReduction').innerText = '-'
      document.getElementById('tableResultTotalRecettes').innerText = '-'
      document.getElementById('tableResultEspeces').innerText = '-'
      document.getElementById('tableResultCheques').innerText = '-'
      document.getElementById('tableResultCB').innerText = '-'
      document.getElementById('tableResultPaylib').innerText = '-'
      document.getElementById('tableResultPaypal').innerText = '-'
      document.getElementById('tableResultConsommables').innerText = '-'
      document.getElementById('tableResultMaterials').innerText = '-'
      document.getElementById('tableResultConsommablesAndMaterials').innerText = '-'
      document.getElementById('tableResultTotalAchats').innerText = '-'
      document.getElementById('tableResultAssurance').innerText = '-'
      document.getElementById('tableResultEssence').innerText = '-'
      document.getElementById('tableResultFraisBancaires').innerText = '-'
      document.getElementById('tableResultSalaire').innerText = '-'
      document.getElementById('tableResultTelephone').innerText = '-'
      document.getElementById('tableResultURSSAF').innerText = '-'
      document.getElementById('tableResultAutres').innerText = '-'
      document.getElementById('tableResultTotalDepenses').innerText = '-'
      document.getElementById('tableResultFinalBankAccount').innerText = '-'
      document.getElementById('tableResultRestant').innerText = '-'
      let date1 = document.getElementById('date1').value + 'T00:00:00'
      let date2 = document.getElementById('date2').value + 'T23:59:00'
      let tableResultQuantity = 0
      let subTotalPrestation = 0
      let subTotalVente = 0
      let subTotalRemise = 0
      let tableResultReduction = 0
      let tableResultTotalRecettes = 0
      let tableResultEspeces = 0
      let tableResultCheques = 0
      let tableResultCB = 0
      let tableResultPaylib = 0
      let tableResultPaypal = 0
      let tableResultFinal = 0
      let tableResultConsommables = 0
      let tableResultMaterials = 0
      let tableResultConsommablesAndMaterials = 0
      let tableResultTotalAchats = 0
      let tableResultAssurance = 0
      let tableResultEssence = 0
      let tableResultFraisBancaires = 0
      let tableResultSalaire = 0
      let tableResultTelephone = 0
      let tableResultURSSAF = 0
      let tableResultAutres = 0
      let tableResultTotalDepenses = 0
      let tableFullRecettes = 0
      let tableFullDepenses = 0
      let myAmountToAddLater = 0
      if (date1 !== 'T00:00:00' && date2 !== 'T23:59:00') {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        // STEP 1 -- Invoices
        await axios
          .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
          .then((response) => {
            if (localStorage.getItem('modePrivilegia') === '3') {
              this.statistics = response.data.filter(invoice => invoice.categoryOfInvoice >= 2)
            } else {
              this.statistics = response.data.filter(invoice => invoice.categoryOfInvoice === 2)
            }
            let myTotalCounter = this.statistics.length
            for (let myCounter = 0; myCounter < myTotalCounter; myCounter++) {
              if (this.statistics[myCounter].date >= date1 && this.statistics[myCounter].date <= date2) {
                // Entrer dans les lignes de chaque commandes
                let myTotalSecondCounter = this.statistics[myCounter].lines.length
                for (let mySecondCounter = 0; mySecondCounter < myTotalSecondCounter; mySecondCounter++) {
                  if (this.statistics[myCounter].lines[mySecondCounter].category === 'Prestation') {
                    subTotalPrestation = subTotalPrestation + this.statistics[myCounter].lines[mySecondCounter].total
                  }
                  if (this.statistics[myCounter].lines[mySecondCounter].category === 'Vente') {
                    subTotalVente = subTotalVente + this.statistics[myCounter].lines[mySecondCounter].total
                  }
                  if (this.statistics[myCounter].lines[mySecondCounter].category === 'Remise') {
                    subTotalRemise = subTotalRemise + this.statistics[myCounter].lines[mySecondCounter].total
                  }
                }
                // Retour aux informations par commande
                // Quantité
                tableResultQuantity++
                document.getElementById('tableResultQuantity').innerText = tableResultQuantity
                // Recettes
                document.getElementById('tableResultPrestations').innerText = subTotalPrestation.toFixed(2) + ' €'
                document.getElementById('tableResultVentes').innerText = subTotalVente.toFixed(2) + ' €'
                document.getElementById('tableResultRemises').innerText = '-' + subTotalRemise.toFixed(2) + ' €'
                tableResultReduction = tableResultReduction + this.statistics[myCounter].amountreduction
                document.getElementById('tableResultReduction').innerText = '-' + tableResultReduction.toFixed(2) + ' €'
                tableResultTotalRecettes = tableResultTotalRecettes + this.statistics[myCounter].totalprice
                document.getElementById('tableResultTotalRecettes').innerText = tableResultTotalRecettes.toFixed(2) + ' €'
                // Par mode
                tableResultEspeces = tableResultEspeces + this.statistics[myCounter].paiementEspeces
                document.getElementById('tableResultEspeces').innerText = tableResultEspeces.toFixed(2) + ' €'
                tableResultCheques = tableResultCheques + this.statistics[myCounter].paiementCheques
                document.getElementById('tableResultCheques').innerText = tableResultCheques.toFixed(2) + ' €'
                tableResultCB = tableResultCB + this.statistics[myCounter].paiementCB
                document.getElementById('tableResultCB').innerText = tableResultCB.toFixed(2) + ' €'
                tableResultPaylib = tableResultPaylib + this.statistics[myCounter].paiementPaylib
                document.getElementById('tableResultPaylib').innerText = tableResultPaylib.toFixed(2) + ' €'
                tableResultPaypal = tableResultPaypal + this.statistics[myCounter].paiementPaypal
                document.getElementById('tableResultPaypal').innerText = tableResultPaypal.toFixed(2) + ' €'
              }
            }
          })
        // STEP 2 -- Spendings
        await axios
          .get(('https://privilegia.fr/api/depenses/'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
          .then((response) => {
            this.spending = response.data
            let myTotalCounter2 = this.spending.length
            for (let myCounter2 = 0; myCounter2 < myTotalCounter2; myCounter2++) {
              if (this.spending[myCounter2].date >= date1 && this.spending[myCounter2].date <= date2) {
                // Achats
                if (this.spending[myCounter2].category === 'Consommables') {
                  tableResultConsommables = tableResultConsommables + this.spending[myCounter2].price
                  document.getElementById('tableResultConsommables').innerText = tableResultConsommables.toFixed(2) + ' €'
                }
                if (this.spending[myCounter2].category === 'Matériel') {
                  tableResultMaterials = tableResultMaterials + this.spending[myCounter2].price
                  document.getElementById('tableResultMaterials').innerText = tableResultMaterials.toFixed(2) + ' €'
                }
                if (this.spending[myCounter2].category === 'Consommables + Matériel') {
                  tableResultConsommablesAndMaterials = tableResultConsommablesAndMaterials + this.spending[myCounter2].price
                  document.getElementById('tableResultConsommablesAndMaterials').innerText = tableResultConsommablesAndMaterials.toFixed(2) + ' €'
                }
                // Total
                tableResultTotalAchats = tableResultConsommables + tableResultMaterials + tableResultConsommablesAndMaterials
                document.getElementById('tableResultTotalAchats').innerText = tableResultTotalAchats.toFixed(2) + ' €'
                // Dépenses
                if (this.spending[myCounter2].category === 'Assurance') {
                  tableResultAssurance = tableResultAssurance + this.spending[myCounter2].price
                  document.getElementById('tableResultAssurance').innerText = tableResultAssurance.toFixed(2) + ' €'
                }
                if (this.spending[myCounter2].category === 'Essence') {
                  tableResultEssence = tableResultEssence + this.spending[myCounter2].price
                  document.getElementById('tableResultEssence').innerText = tableResultEssence.toFixed(2) + ' €'
                }
                if (this.spending[myCounter2].category === 'Frais bancaires') {
                  tableResultFraisBancaires = tableResultFraisBancaires + this.spending[myCounter2].price
                  document.getElementById('tableResultFraisBancaires').innerText = tableResultFraisBancaires.toFixed(2) + ' €'
                }
                if (this.spending[myCounter2].category === 'Salaire') {
                  tableResultSalaire = tableResultSalaire + this.spending[myCounter2].price
                  document.getElementById('tableResultSalaire').innerText = tableResultSalaire.toFixed(2) + ' €'
                }
                if (this.spending[myCounter2].category === 'Téléphone') {
                  tableResultTelephone = tableResultTelephone + this.spending[myCounter2].price
                  document.getElementById('tableResultTelephone').innerText = tableResultTelephone.toFixed(2) + ' €'
                }
                if (this.spending[myCounter2].category === 'URSSAF') {
                  tableResultURSSAF = tableResultURSSAF + this.spending[myCounter2].price
                  document.getElementById('tableResultURSSAF').innerText = tableResultURSSAF.toFixed(2) + ' €'
                }
                if (this.spending[myCounter2].category === 'Autres') {
                  tableResultAutres = tableResultAutres + this.spending[myCounter2].price
                  document.getElementById('tableResultAutres').innerText = tableResultAutres.toFixed(2) + ' €'
                }
                tableResultTotalDepenses = tableResultAssurance + tableResultEssence + tableResultFraisBancaires + tableResultSalaire + tableResultTelephone + tableResultURSSAF + tableResultAutres
                document.getElementById('tableResultTotalDepenses').innerText = tableResultTotalDepenses.toFixed(2) + ' €'
              }
            }
            // Total
            tableResultFinal = tableResultTotalRecettes - tableResultTotalAchats - tableResultTotalDepenses
            document.getElementById('tableResultFinal').innerText = tableResultFinal.toFixed(2) + ' €'
          })
        // STEP 3 -- Compte Courant
        await axios
          .get(('https://privilegia.fr/api/depenses/'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
          .then((response) => {
            this.spending2 = response.data
            let myTotalCounter3 = this.spending2.length
            for (let myCounter3 = 0; myCounter3 < myTotalCounter3; myCounter3++) {
              tableFullDepenses = tableFullDepenses + this.spending2[myCounter3].price
            }
            axios
              .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
              .then((response) => {
                this.statistics2 = response.data.filter(invoice => invoice.categoryOfInvoice === 2 && invoice.dateBank !== '-')
                let myTotalCounter4 = this.statistics2.length
                for (let myCounter4 = 0; myCounter4 < myTotalCounter4; myCounter4++) {
                  tableFullRecettes = tableFullRecettes + this.statistics2[myCounter4].totalprice
                  let tableResultFinalBankAccount = tableFullRecettes.toFixed(2) - tableFullDepenses.toFixed(2)
                  document.getElementById('tableResultFinalBankAccount').innerText = tableResultFinalBankAccount.toFixed(2) + ' €'
                }
              })
          })
          // STEP 4 -- Restant à encaisser
        await axios
          .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
          .then((response) => {
            this.statistics3 = response.data.filter(invoice => invoice.categoryOfInvoice === 2 && invoice.dateBank === '-')
            let myTotalCounter5 = this.statistics3.length
            for (let myCounter5 = 0; myCounter5 < myTotalCounter5; myCounter5++) {
              myAmountToAddLater = myAmountToAddLater + this.statistics3[myCounter5].totalprice
            }
            document.getElementById('tableResultRestant').innerText = myAmountToAddLater.toFixed(2) + ' €'
          })
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppStatistics.vue